import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IdiomaService } from 'src/app/core/services/idioma.service';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-politica-privacidade',
  templateUrl: './politica-privacidade.component.html',
  styleUrls: ['./politica-privacidade.component.scss']
})

export class PoliticaPrivacidadeComponent implements OnInit {
  data: any;

  idiomaSelecionado;
  idiomas;

  constructor(
    private translate: TranslateService,
    private idiomaService: IdiomaService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private gaService: GoogleAnalyticsService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
      this.idiomaSelecionado = this.idiomaService.getIdioma();
    });
  }

  ngOnInit() {
    this.carregarDados();

    this.idiomaSelecionado = this.idiomaService.getIdioma();
    this.idiomas = this.idiomaService.getIdiomas();
  }

  carregarDados() {
    this.translate.get('POLITICA_PRIVACIDADE').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({name: 'description', content: this.data.META_DESCRIPTION});
      this.meta.updateTag({name: 'keywords', content:  this.data.META_KEYWORDS});
      this.gaService.pageView(this.router.url);
    });
  }

  alterarIdioma(idioma) {
    this.translate.use(idioma);
  }
}
